import { render } from "./Android.vue?vue&type=template&id=35469f70&scoped=true"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import "./Android.vue?vue&type=style&index=0&id=35469f70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35469f70"

export default script